<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6>
        <div class="text-xs-center mt-5">
          <v-avatar size="120">
            <img src="@/assets/avatar.jpg" alt="Pratik Abhyankar" class="mb-5">
          </v-avatar>
          <h1 class="display-2">Pratik Abhyankar</h1>
          <br>
          <p class="subheading">Graduate student. North Carolina State University. Computer Science.</p>
          <br><hr color="lightgrey"><br>
          <a :href="linkedInLink" target="_blank">
            <v-btn fab color="grey darken-3" title="LinkedIn" dark>
              <i class="fab fa-linkedin-in"></i>
            </v-btn>
          </a>
          <a :href="githubLink" target="_blank">
            <v-btn fab color="grey darken-3" title="Github" dark>
              <i class="fab fa-github"></i>
            </v-btn>
          </a>
          <a :href="facebookLink" target="_blank">
            <v-btn fab color="grey darken-3" title="Facebook" dark>
              <i class="fab fa-facebook-f"></i>
            </v-btn>
          </a>
          <a :href="mailLink" target="_blank">
            <v-btn fab color="grey darken-3" title="Email" dark>
              <i class="far fa-envelope"></i>
            </v-btn>
          </a>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      linkedInLink: 'https://www.linkedin.com/in/pratik-abhyankar/',
      githubLink: 'https://www.github.com/pratik-abhyankar/',
      facebookLink: 'https://www.facebook.com/abhyankarpratik',
      mailLink: 'mailto:abhyankarpratik@gmail.com'
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  i {
    font-size: 1.5rem;
  }
  a {
    text-decoration: none;
    outline: none;
  }
</style>
